/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendCapexDto } from '../models/backend-capex-dto';
import { BackendCapexObjectDto } from '../models/backend-capex-object-dto';
import { BackendCapexObjectFilesDto } from '../models/backend-capex-object-files-dto';
import { BackendCapexVariantDto } from '../models/backend-capex-variant-dto';
import { economicIndicatorsCapexObjectFilesPartialUpdate } from '../fn/capexs/economic-indicators-capex-object-files-partial-update';
import { economicIndicatorsCapexObjectFilesPartialUpdate$FormData } from '../fn/capexs/economic-indicators-capex-object-files-partial-update-form-data';
import { EconomicIndicatorsCapexObjectFilesPartialUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-object-files-partial-update-form-data';
import { EconomicIndicatorsCapexObjectFilesPartialUpdate$Params } from '../fn/capexs/economic-indicators-capex-object-files-partial-update';
import { economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-object-files-partial-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-object-files-partial-update-x-www-form-urlencoded';
import { economicIndicatorsCapexObjectFilesUpdate } from '../fn/capexs/economic-indicators-capex-object-files-update';
import { economicIndicatorsCapexObjectFilesUpdate$FormData } from '../fn/capexs/economic-indicators-capex-object-files-update-form-data';
import { EconomicIndicatorsCapexObjectFilesUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-object-files-update-form-data';
import { EconomicIndicatorsCapexObjectFilesUpdate$Params } from '../fn/capexs/economic-indicators-capex-object-files-update';
import { economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-object-files-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-object-files-update-x-www-form-urlencoded';
import { economicIndicatorsCapexObjectSettingsPartialUpdate } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update';
import { economicIndicatorsCapexObjectSettingsPartialUpdate$FormData } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update-form-data';
import { EconomicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update-form-data';
import { EconomicIndicatorsCapexObjectSettingsPartialUpdate$Params } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update';
import { economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-object-settings-partial-update-x-www-form-urlencoded';
import { economicIndicatorsCapexObjectSettingsUpdate } from '../fn/capexs/economic-indicators-capex-object-settings-update';
import { economicIndicatorsCapexObjectSettingsUpdate$FormData } from '../fn/capexs/economic-indicators-capex-object-settings-update-form-data';
import { EconomicIndicatorsCapexObjectSettingsUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-object-settings-update-form-data';
import { EconomicIndicatorsCapexObjectSettingsUpdate$Params } from '../fn/capexs/economic-indicators-capex-object-settings-update';
import { economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-object-settings-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-object-settings-update-x-www-form-urlencoded';
import { economicIndicatorsCapexsCopyCreate } from '../fn/capexs/economic-indicators-capexs-copy-create';
import { EconomicIndicatorsCapexsCopyCreate$Params } from '../fn/capexs/economic-indicators-capexs-copy-create';
import { economicIndicatorsCapexsCreate } from '../fn/capexs/economic-indicators-capexs-create';
import { economicIndicatorsCapexsCreate$FormData } from '../fn/capexs/economic-indicators-capexs-create-form-data';
import { EconomicIndicatorsCapexsCreate$FormData$Params } from '../fn/capexs/economic-indicators-capexs-create-form-data';
import { EconomicIndicatorsCapexsCreate$Params } from '../fn/capexs/economic-indicators-capexs-create';
import { economicIndicatorsCapexsCreate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capexs-create-x-www-form-urlencoded';
import { EconomicIndicatorsCapexsCreate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capexs-create-x-www-form-urlencoded';
import { economicIndicatorsCapexsDestroy } from '../fn/capexs/economic-indicators-capexs-destroy';
import { EconomicIndicatorsCapexsDestroy$Params } from '../fn/capexs/economic-indicators-capexs-destroy';
import { economicIndicatorsCapexsDestroy2 } from '../fn/capexs/economic-indicators-capexs-destroy-2';
import { EconomicIndicatorsCapexsDestroy2$Params } from '../fn/capexs/economic-indicators-capexs-destroy-2';
import { economicIndicatorsCapexsEnumsRetrieve } from '../fn/capexs/economic-indicators-capexs-enums-retrieve';
import { EconomicIndicatorsCapexsEnumsRetrieve$Params } from '../fn/capexs/economic-indicators-capexs-enums-retrieve';
import { economicIndicatorsCapexsList } from '../fn/capexs/economic-indicators-capexs-list';
import { EconomicIndicatorsCapexsList$Params } from '../fn/capexs/economic-indicators-capexs-list';
import { economicIndicatorsCapexsPartialUpdate } from '../fn/capexs/economic-indicators-capexs-partial-update';
import { economicIndicatorsCapexsPartialUpdate$FormData } from '../fn/capexs/economic-indicators-capexs-partial-update-form-data';
import { EconomicIndicatorsCapexsPartialUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capexs-partial-update-form-data';
import { EconomicIndicatorsCapexsPartialUpdate$Params } from '../fn/capexs/economic-indicators-capexs-partial-update';
import { economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capexs-partial-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capexs-partial-update-x-www-form-urlencoded';
import { economicIndicatorsCapexsRetrieve } from '../fn/capexs/economic-indicators-capexs-retrieve';
import { EconomicIndicatorsCapexsRetrieve$Params } from '../fn/capexs/economic-indicators-capexs-retrieve';
import { economicIndicatorsCapexsUpdate } from '../fn/capexs/economic-indicators-capexs-update';
import { economicIndicatorsCapexsUpdate$FormData } from '../fn/capexs/economic-indicators-capexs-update-form-data';
import { EconomicIndicatorsCapexsUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capexs-update-form-data';
import { EconomicIndicatorsCapexsUpdate$Params } from '../fn/capexs/economic-indicators-capexs-update';
import { economicIndicatorsCapexsUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capexs-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capexs-update-x-www-form-urlencoded';
import { economicIndicatorsCapexVariantsCopyCreate } from '../fn/capexs/economic-indicators-capex-variants-copy-create';
import { EconomicIndicatorsCapexVariantsCopyCreate$Params } from '../fn/capexs/economic-indicators-capex-variants-copy-create';
import { economicIndicatorsCapexVariantsCreate } from '../fn/capexs/economic-indicators-capex-variants-create';
import { economicIndicatorsCapexVariantsCreate$FormData } from '../fn/capexs/economic-indicators-capex-variants-create-form-data';
import { EconomicIndicatorsCapexVariantsCreate$FormData$Params } from '../fn/capexs/economic-indicators-capex-variants-create-form-data';
import { EconomicIndicatorsCapexVariantsCreate$Params } from '../fn/capexs/economic-indicators-capex-variants-create';
import { economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-variants-create-x-www-form-urlencoded';
import { EconomicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-variants-create-x-www-form-urlencoded';
import { economicIndicatorsCapexVariantsDestroy } from '../fn/capexs/economic-indicators-capex-variants-destroy';
import { EconomicIndicatorsCapexVariantsDestroy$Params } from '../fn/capexs/economic-indicators-capex-variants-destroy';
import { economicIndicatorsCapexVariantsList } from '../fn/capexs/economic-indicators-capex-variants-list';
import { EconomicIndicatorsCapexVariantsList$Params } from '../fn/capexs/economic-indicators-capex-variants-list';
import { economicIndicatorsCapexVariantsPartialUpdate } from '../fn/capexs/economic-indicators-capex-variants-partial-update';
import { economicIndicatorsCapexVariantsPartialUpdate$FormData } from '../fn/capexs/economic-indicators-capex-variants-partial-update-form-data';
import { EconomicIndicatorsCapexVariantsPartialUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-variants-partial-update-form-data';
import { EconomicIndicatorsCapexVariantsPartialUpdate$Params } from '../fn/capexs/economic-indicators-capex-variants-partial-update';
import { economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-variants-partial-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-variants-partial-update-x-www-form-urlencoded';
import { economicIndicatorsCapexVariantsRetrieve } from '../fn/capexs/economic-indicators-capex-variants-retrieve';
import { EconomicIndicatorsCapexVariantsRetrieve$Params } from '../fn/capexs/economic-indicators-capex-variants-retrieve';
import { economicIndicatorsCapexVariantsUpdate } from '../fn/capexs/economic-indicators-capex-variants-update';
import { economicIndicatorsCapexVariantsUpdate$FormData } from '../fn/capexs/economic-indicators-capex-variants-update-form-data';
import { EconomicIndicatorsCapexVariantsUpdate$FormData$Params } from '../fn/capexs/economic-indicators-capex-variants-update-form-data';
import { EconomicIndicatorsCapexVariantsUpdate$Params } from '../fn/capexs/economic-indicators-capex-variants-update';
import { economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-capex-variants-update-x-www-form-urlencoded';
import { EconomicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-capex-variants-update-x-www-form-urlencoded';
import { economicIndicatorsUnblockCapexsVariantsCreate } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create';
import { economicIndicatorsUnblockCapexsVariantsCreate$FormData } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create-form-data';
import { EconomicIndicatorsUnblockCapexsVariantsCreate$FormData$Params } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create-form-data';
import { EconomicIndicatorsUnblockCapexsVariantsCreate$Params } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create';
import { economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create-x-www-form-urlencoded';
import { EconomicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/capexs/economic-indicators-unblock-capexs-variants-create-x-www-form-urlencoded';
import { BackendIdDto } from '../models/backend-id-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiCapexsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `economicIndicatorsCapexObjectFilesUpdate()` */
  static readonly EconomicIndicatorsCapexObjectFilesUpdatePath = '/api/economic_indicators/capex_object_files/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectFilesUpdate$Response(
    params: EconomicIndicatorsCapexObjectFilesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectFilesUpdate(
    params: EconomicIndicatorsCapexObjectFilesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectFilesUpdate$FormData$Response(
    params: EconomicIndicatorsCapexObjectFilesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectFilesUpdate$FormData(
    params: EconomicIndicatorsCapexObjectFilesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexObjectFilesPartialUpdate()` */
  static readonly EconomicIndicatorsCapexObjectFilesPartialUpdatePath =
    '/api/economic_indicators/capex_object_files/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate$Response(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectFilesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate$FormData$Response(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectFilesDto>> {
    return economicIndicatorsCapexObjectFilesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectFilesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectFilesPartialUpdate$FormData(
    params: EconomicIndicatorsCapexObjectFilesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectFilesDto> {
    return this.economicIndicatorsCapexObjectFilesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectFilesDto>): BackendCapexObjectFilesDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexObjectSettingsUpdate()` */
  static readonly EconomicIndicatorsCapexObjectSettingsUpdatePath =
    '/api/economic_indicators/capex_object_settings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectSettingsUpdate$Response(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectSettingsUpdate(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectSettingsUpdate$FormData$Response(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectSettingsUpdate$FormData(
    params: EconomicIndicatorsCapexObjectSettingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexObjectSettingsPartialUpdate()` */
  static readonly EconomicIndicatorsCapexObjectSettingsPartialUpdatePath =
    '/api/economic_indicators/capex_object_settings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate$Response(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded(
      this.http,
      this.rootUrl,
      params,
      context,
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexObjectSettingsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Response(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
    return economicIndicatorsCapexObjectSettingsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexObjectSettingsPartialUpdate$FormData(
    params: EconomicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexObjectDto> {
    return this.economicIndicatorsCapexObjectSettingsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexObjectDto>): BackendCapexObjectDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsList()` */
  static readonly EconomicIndicatorsCapexVariantsListPath = '/api/economic_indicators/capex_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsList$Response(
    params?: EconomicIndicatorsCapexVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCapexVariantDto>>> {
    return economicIndicatorsCapexVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsList(
    params?: EconomicIndicatorsCapexVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCapexVariantDto>> {
    return this.economicIndicatorsCapexVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCapexVariantDto>>): Array<BackendCapexVariantDto> => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsCreate()` */
  static readonly EconomicIndicatorsCapexVariantsCreatePath = '/api/economic_indicators/capex_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsCreate$Response(
    params: EconomicIndicatorsCapexVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsCreate(
    params: EconomicIndicatorsCapexVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsCreate$FormData$Response(
    params: EconomicIndicatorsCapexVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsCreate$FormData(
    params: EconomicIndicatorsCapexVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsRetrieve()` */
  static readonly EconomicIndicatorsCapexVariantsRetrievePath = '/api/economic_indicators/capex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsRetrieve$Response(
    params: EconomicIndicatorsCapexVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsRetrieve(
    params: EconomicIndicatorsCapexVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsUpdate()` */
  static readonly EconomicIndicatorsCapexVariantsUpdatePath = '/api/economic_indicators/capex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsUpdate$Response(
    params: EconomicIndicatorsCapexVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsUpdate(
    params: EconomicIndicatorsCapexVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsUpdate$FormData$Response(
    params: EconomicIndicatorsCapexVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsUpdate$FormData(
    params: EconomicIndicatorsCapexVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsDestroy()` */
  static readonly EconomicIndicatorsCapexVariantsDestroyPath = '/api/economic_indicators/capex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsDestroy$Response(
    params: EconomicIndicatorsCapexVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsDestroy(
    params: EconomicIndicatorsCapexVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsPartialUpdate()` */
  static readonly EconomicIndicatorsCapexVariantsPartialUpdatePath = '/api/economic_indicators/capex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsPartialUpdate$Response(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexVariantsPartialUpdate(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsPartialUpdate$FormData$Response(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
    return economicIndicatorsCapexVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexVariantsPartialUpdate$FormData(
    params: EconomicIndicatorsCapexVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexVariantDto> {
    return this.economicIndicatorsCapexVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexVariantDto>): BackendCapexVariantDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexVariantsCopyCreate()` */
  static readonly EconomicIndicatorsCapexVariantsCopyCreatePath = '/api/economic_indicators/capex_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsCopyCreate$Response(
    params: EconomicIndicatorsCapexVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexVariantsCopyCreate(
    params: EconomicIndicatorsCapexVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsList()` */
  static readonly EconomicIndicatorsCapexsListPath = '/api/economic_indicators/capexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsList$Response(
    params?: EconomicIndicatorsCapexsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendCapexDto>>> {
    return economicIndicatorsCapexsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsList(
    params?: EconomicIndicatorsCapexsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendCapexDto>> {
    return this.economicIndicatorsCapexsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendCapexDto>>): Array<BackendCapexDto> => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsCreate()` */
  static readonly EconomicIndicatorsCapexsCreatePath = '/api/economic_indicators/capexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsCreate$Response(
    params?: EconomicIndicatorsCapexsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsCreate(
    params?: EconomicIndicatorsCapexsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsCreate$XWwwFormUrlencoded$Response(
    params?: EconomicIndicatorsCapexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsCreate$XWwwFormUrlencoded(
    params?: EconomicIndicatorsCapexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsCreate$FormData$Response(
    params?: EconomicIndicatorsCapexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsCreate$FormData(
    params?: EconomicIndicatorsCapexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsDestroy()` */
  static readonly EconomicIndicatorsCapexsDestroyPath = '/api/economic_indicators/capexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsDestroy$Response(
    params?: EconomicIndicatorsCapexsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsDestroy(
    params?: EconomicIndicatorsCapexsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsRetrieve()` */
  static readonly EconomicIndicatorsCapexsRetrievePath = '/api/economic_indicators/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsRetrieve$Response(
    params: EconomicIndicatorsCapexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsRetrieve(
    params: EconomicIndicatorsCapexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsUpdate()` */
  static readonly EconomicIndicatorsCapexsUpdatePath = '/api/economic_indicators/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsUpdate$Response(
    params: EconomicIndicatorsCapexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsUpdate(
    params: EconomicIndicatorsCapexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsUpdate$FormData$Response(
    params: EconomicIndicatorsCapexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsUpdate$FormData(
    params: EconomicIndicatorsCapexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsDestroy2()` */
  static readonly EconomicIndicatorsCapexsDestroy2Path = '/api/economic_indicators/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsDestroy2()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsDestroy2$Response(
    params: EconomicIndicatorsCapexsDestroy2$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexsDestroy2(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsDestroy2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsDestroy2(
    params: EconomicIndicatorsCapexsDestroy2$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexsDestroy2$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsPartialUpdate()` */
  static readonly EconomicIndicatorsCapexsPartialUpdatePath = '/api/economic_indicators/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsPartialUpdate$Response(
    params: EconomicIndicatorsCapexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsCapexsPartialUpdate(
    params: EconomicIndicatorsCapexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded(
    params: EconomicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsPartialUpdate$FormData$Response(
    params: EconomicIndicatorsCapexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCapexDto>> {
    return economicIndicatorsCapexsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsCapexsPartialUpdate$FormData(
    params: EconomicIndicatorsCapexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCapexDto> {
    return this.economicIndicatorsCapexsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCapexDto>): BackendCapexDto => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsCopyCreate()` */
  static readonly EconomicIndicatorsCapexsCopyCreatePath = '/api/economic_indicators/capexs/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsCopyCreate$Response(
    params: EconomicIndicatorsCapexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsCopyCreate(
    params: EconomicIndicatorsCapexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsCapexsEnumsRetrieve()` */
  static readonly EconomicIndicatorsCapexsEnumsRetrievePath = '/api/economic_indicators/capexs/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsCapexsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsEnumsRetrieve$Response(
    params: EconomicIndicatorsCapexsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return economicIndicatorsCapexsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsCapexsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  economicIndicatorsCapexsEnumsRetrieve(
    params: EconomicIndicatorsCapexsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.economicIndicatorsCapexsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `economicIndicatorsUnblockCapexsVariantsCreate()` */
  static readonly EconomicIndicatorsUnblockCapexsVariantsCreatePath =
    '/api/economic_indicators/unblock-capexs-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsUnblockCapexsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate$Response(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return economicIndicatorsUnblockCapexsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsUnblockCapexsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.economicIndicatorsUnblockCapexsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Response(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.economicIndicatorsUnblockCapexsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `economicIndicatorsUnblockCapexsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate$FormData$Response(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return economicIndicatorsUnblockCapexsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `economicIndicatorsUnblockCapexsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  economicIndicatorsUnblockCapexsVariantsCreate$FormData(
    params: EconomicIndicatorsUnblockCapexsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.economicIndicatorsUnblockCapexsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
